<template>
  <div>
    <div class="five-top">
      <!--<img class="five-top-bg" src="/static/images/five-steps-bg.png" alt="">-->
      <div class="five-top-con">
        <h2 class="name">{{info.fullName}}</h2>
        <div class="five-rules">
          <div><i>1、</i><p>假设 退休年龄<span>{{info.retirement}}</span>岁，您最长有 <span>{{info.reserve}}</span> 年储备养老；</p></div>
          <div><i>2、</i>
            <p>根据您<span>{{info.annualincome}}</span>万的年收入测算，按照<span>{{info.quality}}</span>%的养老品质线，您所需要的养老金应不 低于每年<span>{{info.needannuity}}</span>万；</p>
          </div>
          <div>
            <i>3、</i>
            <p>如果退休后养老金综合替代率为<span>{{info.substitution}}</span>%，那么每年可以领取的养老金是<span>{{info.receiveannuity}}</span>万；</p>
          </div>
          <div>
            <i>4、</i>
            <p>所以，您退休后养老金缺口为每年<span>{{info.gapannuity}}</span>万</p>
          </div>
          <div>
            <i>5、</i>
            <p>假设退休后养老金收益率为<span>{{info.annuityprofit}}</span>%，那么只需本金<span>{{info.principal}}</span>万，即可实现每年终身领取养老金 <span>{{info.lifelongannuity}}</span>万；</p>
          </div>
          <div style="margin-top: 0.2rem;margin-bottom: 0.2rem">
            如果养老产品收益率为<span>{{info.productprofit}}</span>%，在<span>{{info.reserve}}</span>年投资复利下，为达到<span>{{info.principal}}</span>万的本金，当前的储蓄总额仅需要<span>{{info.savings}}</span>万，即可锁定养老品质，确保幸福晚年。
          </div>
          <div>不同缴费期储蓄金额参考如下：</div>
          <div><span>3</span>年存，每年预估<span>{{info.threesavings}}</span>万；</div>
          <div><span>5</span>年存，每年预估<span>{{info.fivesavings}}</span>万；</div>
          <div><span>10</span>年存，每年预估<span>{{info.tensavings}}</span>万；</div>





        </div>
      </div>
    </div>
    <div class="five-mid">
      养老金规划标准
    </div>
    <div style="padding: 0 0.2rem;background-color: #d2ab7f">
      <div class="five-bottom">

        <div class="new-box">
           <img class="login-img" src="/static/images/logo2.png" alt="">
            <div class="new-one">
              <div class="item one">③ 初始本金<span>{{info.savings}}</span>万
                <div class="top-txt">{{info.reserve}}年养老储蓄</div>
                <img class="row" src="/static/images/row3.png" alt="">
              </div>
              <div class="item two">
                <img class="bg" src="/static/images/row1.png" alt="">
              </div>

              <div class="item three">② 所需本金<span>{{info.principal}}</span>万
                <img class="row" src="/static/images/row4.png" alt="">
                <i>{{info.annuityprofit}}%</i>
              </div>
            </div>
            <div class="new-one" style="margin-bottom: 0">
              <div class="item one">④ {{info.customizeyear}}年交*<span>{{info.customizesavings}}万</span>
                <div class="top-txt">锁定晚年品质</div>

              </div>
              <div class="item two">

                <img class="bg" src="/static/images/row2.png" alt="">
              </div>

              <div class="item three">① 养老缺口<span>{{info.gapannuity}}万/</span>年

              </div>
            </div>
            <div class="new-all">
              <img class="bg" src="/static/images/row5.png" alt="">
              <div class="new-all-item one">
                <span>{{info.retirement-info.reserve}}岁</span>
                <img  src="/static/images/row6.png" alt="">
              </div>
              <div class="new-all-item two">
                <span>{{info.retirement}}岁</span>
                <img src="/static/images/row7.png" alt="">
              </div>
            </div>
        </div>



        <!--<div class="huo-box">-->
          <!--<div class="top">-->
            <!--<div class="item1">-->
              <!--初始本金<span>{{info.savings}}</span>万-->
            <!--</div>-->
            <!--<div class="item2">{{info.reserve}}年养老储蓄</div>-->
            <!--<div class="item3">所需本金<span>{{info.principal}}</span>万</div>-->
          <!--</div>-->
          <!--<div class="mid">-->
            <!--<div class="item1">{{info.customizeyear}}年交*<span>{{info.customizesavings}}万</span></div>-->
            <!--<div class="item2">锁定晚年品质</div>-->
            <!--<div class="item3">养老缺口<span>{{info.gapannuity}}万/</span>年</div>-->
            <!--<div class="item4">{{info.annuityprofit}}%</div>-->
          <!--</div>-->
          <!--<div class="bottom">-->
            <!--<div class="item1">{{info.retirement-info.reserve}}岁</div>-->
            <!--<div class="item2">{{info.retirement}}岁</div>-->
          <!--</div>-->

        <!--</div>-->
        <div class="five-bottom-con">
          <h1>养老金规划的标准</h1>
          <div class="txt" v-html="remark"></div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'fiveSteps',
  data () {
    return {
      id:'',
      token:'',
      info:{},// 详情
      remark:'',//养老金规划标准
      // year:'',// 年
      // count:'',// 数
    }
  },
  mounted(){
    if(this.getUrlParamURLys("id")){
      this.id=this.getUrlParamURLys("id");
      this.token=this.getUrlParamURLys("token");
      this.getinfo();
      this.getSing();
    }
    // if(this.getUrlParamURLys("year")){
    //   this.year=this.getUrlParamURLys("year")
    // }
    // if(this.getUrlParamURLys("count")){
    //   this.count=this.getUrlParamURLys("count")
    // }
  },
  methods:{
    getinfo:function () {
      var _this=this;
      _this.call_net("POST","/api/app/tool/pensioninfo",{id:_this.id,token:_this.token},function (data) {
        if(data.code===200){
          _this.info=data.data;
        }else {
          Yeffect.mAlert(data.desc);
        }
      });
    },
    // 获取养老金规划标准
    getSing:function () {
      var _this=this;
      _this.call_net("POST","/api/app/singlepage/info",{type:14},function (data) {
        if(data.code===200){
          _this.remark=data.data.content;
        }else {
          Yeffect.mAlert(data.desc);
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .new-box{
    padding: 0 0.1rem;
    padding-top: 1rem;
    margin-bottom: 2rem;
  }
  .new-box img.login-img{
    display: block;
    margin-bottom: 0.6rem;
  }
  .new-box img.bg{
    display: block;
    width: 100%;
  }
  .new-box .new-one{
    color: #333;
    font-size: 0;
    margin-bottom: 0.56rem;
  }
  .new-box .new-one span{
    color: #c99f5f;
    font-size: .28rem;
  }
  .new-box .new-one .item.one,
  .new-box .new-one .item.three{
    width: 40%;
  }
  .new-box .new-one .item .row{
    position: absolute;
    left: 50%;
    top:0.5rem;
    height: 0.4rem;
  }
  .new-box .new-one .item i{
    position: absolute;
    left: 60%;
    top:0.5rem;
    font-size: 0.26rem;
    color: #333;
  }
  .new-box .new-one .item.two{
    width: 20%;
  }
  .new-box .new-one .item{
    display: inline-block;
    vertical-align: middle;
    font-size: 0.26rem;
    position: relative;
  }
  .new-box .new-one .item .top-txt{
    position: absolute;
    font-size: 0.26rem;
    color: #333;
    position: absolute;
    font-size: 0.26rem;
    color: #333;
    bottom: 0.4rem;
    right: -1.64rem;
  }
  .new-box .new-one img{
    display: inline-block;
    vertical-align: middle;

  }
  .new-all{
    margin-top: 0.2rem;
  }
  .new-all .new-all-item{
    float: left;
    width: 50%;
    text-align: center;
    margin-top: 0.2rem;
  }
  .new-all .new-all-item span{
    display: inline-block;
    font-size: .36rem;
    color: #333;
    vertical-align: middle;
  }
  .new-all .new-all-item.one img{
    display: inline-block;
    width: 1rem;
    vertical-align: middle;
  }
  .new-all .new-all-item.two img{
    display: inline-block;
    height: 1rem;
    vertical-align: middle;
  }

 .five-top{
   display: block;
   width: 100%;
   background: url("/static/images/five-steps-bg.png") no-repeat center center;
   background-size: 100% 100%;
 }
 .five-top{
   position: relative;
 }
 .five-top .five-top-con{
    /*position: relative;*/
   width: 100%;
    /*top:0.5rem;*/
    padding: 0.3rem;
   box-sizing: border-box;
  }
 .five-top .five-top-con h2.name{
   font-size: 0.72rem;
   color: #2e230a;
   font-weight: normal;
   padding-left: 0.6rem;
   min-height: 1rem;
 }
 .five-top .five-top-con .five-rules{
   margin-top: 2rem;
   padding: 0 0.4rem;
 }
 .five-top .five-top-con .five-rules>div{
   font-size: 0.3rem;
   color: #333333;
   line-height: 0.5rem;
   margin-bottom: 0.1rem;
   overflow: hidden;
 }
 .five-top .five-top-con .five-rules>div i{
   float: left;

 }
 .five-top .five-top-con .five-rules>div p{
   float: left;
   width: 90%;
 }
 .five-top .five-top-con .five-rules>div  span{
   color: #c99f5f;
   font-size: 0.36rem;
 }
.five-mid{
  background-color: #dab489;
  height: 1.44rem;
  line-height: 1.44rem;
  text-align: center;
  font-size: 0.36rem;
  color: #2e230a;
  letter-spacing: 0.1rem;
}
  .five-bottom{
    position: relative;
    box-sizing: border-box;
    background: url("/static/images/five-steps-bg2.png") no-repeat center center;
    background-size: 100% 100%;
  }
 .five-bottom .five-top-bg2{
   display: block;
   width: 100%;
 }
 .five-bottom .huo-box{
   width: 100%;
   /*padding-top: 1.6rem;*/
   padding-left: 0.5rem;
   box-sizing: border-box;
 }
 .five-bottom .huo-box .mid{
   margin-top: 0.3rem;
   /*position: relative;*/
 }
 .five-bottom .huo-box .mid .item2{
   margin-left: 0.2rem;
 }

 .five-bottom .huo-box .item1, .five-bottom .huo-box .item2, .five-bottom .huo-box .item3{
   font-size: 0.26rem;
   color: #333;
   display: inline-block;
 }
 .five-bottom .huo-box .item1 span, .five-bottom .huo-box .item2 span, .five-bottom .huo-box .item3 span{
   color: #c99f5f;
   font-size: 0.32rem;
 }
 .five-bottom .huo-box .item1{
   margin-left: 0.2rem;
 }
 .five-bottom .huo-box .item2{
   position: relative;
   top: -0.4rem;
 }
 .five-bottom .huo-box .item3{
   margin-left: 0.5rem;
 }
 .five-bottom .huo-box .item4{
   display: inline-block;
   font-size: 0.28rem;
   right: 0;
   color: #000;
   position: relative;
   top: -0.4rem;
   left: -1rem;
}
 .five-bottom .huo-box .mid .item3{
   margin-left: 0.3rem;
 }
 .five-bottom .huo-box .bottom{
   margin-top: 0.6rem;
 }
 .five-bottom .huo-box .bottom .item1{
   font-size: 0.36rem;
   margin-left: 0;
 }
 .five-bottom .huo-box .bottom .item2{
   font-size: 0.36rem;
   margin-left: 3rem;
   top:0;

 }
 .five-bottom .five-bottom-con{
   width: 100%;
   padding: 0.3rem;
   -webkit-box-sizing: border-box;
   box-sizing: border-box;
 }
 .five-bottom .five-bottom-con h1{
   color: #d7b177;
   font-size: 0.32rem;
   margin-bottom: 0.2rem;
 }
 .five-bottom .five-bottom-con .txt{
   font-size: 0.26rem;
   color: #333333;
 }
</style>



// WEBPACK FOOTER //
// src/components/fiveSteps.vue